<template>
	<span>
	<span class="clicker" 
		v-if="mode != 'dice'"
		:style="`cursor:${lastAction == '+' ? 'n-resize' : 's-resize'}`"
		@click="add()"
		@contextmenu="subtract($event)"
		>{{ value}}</span>
	<svg v-if="mode == 'dice'" height="22" width="22"
			 class="dice"
			 :style="`background-color:#${color};`"
			 @click="add()" @contextmenu="subtract($event)">
		<circle cx="5" cy="5" r="2" :style="getPipColor(0)" />
		<circle cx="5" cy="10" r="2" :style="getPipColor(1)" />
		<circle cx="5" cy="15" r="2" :style="getPipColor(2)" />
		<circle cx="10" cy="10" r="2" :style="getPipColor(3)" />
		<circle cx="15" cy="5" r="2" :style="getPipColor(4)" />
		<circle cx="15" cy="10" r="2" :style="getPipColor(5)" />
		<circle cx="15" cy="15" r="2" :style="getPipColor(6)" />
	</svg>
	</span>
</template>

<script>
export default {
	name: 'Clicker',
	props: ["mode", "color", "value"],
	data() {
		return {
			lastAction: "+",
			internalValue: this.value,
			dicePips: [
				[0, 0, 0, 0, 0, 0, 0],
				[0, 0, 0, 1, 0, 0, 0],
				[1, 0, 0, 0, 0, 0, 1],
				[1, 0, 0, 1, 0, 0, 1],
				[1, 0, 1, 0, 1, 0, 1],
				[1, 0, 1, 1, 1, 0, 1],
				[1, 1, 1, 0, 1, 1, 1]]
		}
	},
	methods: {
		add() {
			this.internalValue = Math.round(this.internalValue + 1);
			if (this.mode == "dice") {
				this.internalValue = Math.min(this.internalValue, 6);
			}
			this.$emit('input', this.internalValue)
			this.lastAction = "+";
		},
		subtract(evt) {
			evt.preventDefault();
			this.internalValue = Math.round(Math.max(this.internalValue - 1, (this.mode == "dice" ? 1 : 0)));
			this.$emit('input', this.internalValue)
			this.lastAction = "-";
		},
		getPipColor(num) {
			let pipColor = this.invertColor(this.color, false);
			return this.dicePips[this.value][num] == 1 ? `fill:#${pipColor}` : `fill:#${this.color}`;
		},
		invertColor(hex, bw) {
			let r = parseInt(hex.slice(0, 2), 16);
			let g = parseInt(hex.slice(2, 4), 16);
			let b = parseInt(hex.slice(4, 6), 16);
			if (bw) {
				return (r * 0.299 + g * 0.587 + b * 0.114) > 186 ? '000000' : 'FFFFFF';
			}
			r = (255 - r).toString(16).padStart(2, "0");
			g = (255 - g).toString(16).padStart(2, "0");
			b = (255 - b).toString(16).padStart(2, "0");
			return r + g + b;
		}
	}
}
</script>

<style scoped>
.clicker {
	font-weight: 600;
	font-size: 18px;
	color: darkblue;
	background-color: #eeeeee;
}

.dice {
	border: 1px solid black;
	margin-right: 2px;
	border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/gemini/Clicker.vue